module.exports = __webpack_public_path__ + "static/media/buyer-program-2026.58b55355.pdf";